import * as React from 'react';

var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgPaymentGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "6 11.5 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 11.5H8a2 2 0 00-2 2v17a2 2 0 002 2h28a2 2 0 002-2v-17a2 2 0 00-2-2z",
    fill: "#FFF4D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.862 15.5c-1.375-.007-2.713 1.263-2.102 2.84h-2.306c-.385 0-.755.146-1.028.408a1.367 1.367 0 00-.426.986v1.395c0 .185.077.363.213.494.136.13.321.204.514.204h6.546v-2.093h1.454v2.093h6.546a.743.743 0 00.514-.204.684.684 0 00.213-.494v-1.395c0-.37-.153-.725-.426-.986a1.487 1.487 0 00-1.029-.409H26.24c.85-2.28-2.35-3.892-3.825-1.925l-.415.53-.415-.544c-.458-.62-1.09-.893-1.723-.9zm-.044 1.444c.647 0 .975.753.516 1.193-.458.44-1.243.125-1.243-.495 0-.186.076-.363.213-.494a.743.743 0 01.514-.204zm4.364 0c.647 0 .974.753.516 1.193-.458.44-1.244.125-1.244-.495 0-.186.077-.363.214-.494a.743.743 0 01.514-.204zm-9.455 5.58v5.58c0 .37.153.726.426.987.273.262.643.409 1.029.409h11.636c.386 0 .756-.147 1.029-.409.272-.261.426-.616.426-.986v-5.58h-6.546v5.58h-1.454v-5.58h-6.546z",
    fill: "#C49C39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 32.5H8a2 2 0 01-2-2v-17a2 2 0 012-2h28a2 2 0 012 2v17a2 2 0 01-2 2zM8.143 12.812a1 1 0 00-1 1v16.376a1 1 0 001 1h27.715a1 1 0 001-1V13.812a1 1 0 00-1-1H8.143z",
    fill: "#C39C39"
  })));
}

export { SvgPaymentGift as ReactComponent };
